import { cx } from "utils";


interface AnnualBillingToggleProps {
  isYearly: boolean;
  onChange: (isYearly: boolean) => void;
}

export default function AnnualBillingToggle({ isYearly, onChange }: AnnualBillingToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isYearly}
      onClick={() => onChange(!isYearly)}
      className="inline-flex items-center gap-2 cursor-pointer"
    >
      <span
        className={cx(
          "relative inline-flex h-4 w-7 items-center rounded-full transition-colors",
          isYearly ? "bg-primary-600 justify-end" : "bg-neutral-300 justify-start"
        )}
      >
        <span className="inline-block h-3 w-3 mx-0.5 rounded-full bg-white" />
      </span>
      <span className="text-base leading-6 text-neutral-900">
        Save 10% with annual billing
      </span>
    </button>
  );
}
